import {ActionBrick, registerBrick, ErrorFlow, File} from 'olympe';
import {getLogger} from '@olympeio/core';
import XLSX from 'xlsx';

import {createErrorFlowMessage, isValidConfig, loadConfig, validateCells} from './dataFormatHandlers';

export default class ValidateExcel extends ActionBrick {
    /**
     * @override
     */
    init($) {
        this.logger = getLogger('ValidateExcel');
    }
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {File} file
     * @param {Object} configType
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     */
    async update($, [file, configType], [forwardEvent, setErrorFlow]) {
        try {
            // Guards to validate inputs
            if (!(file instanceof File)) {
                throw new Error('Provided file is not a File');
            }

            if (!isValidConfig(configType)) {
                throw new Error('Invalid configuration type provided, should extend Validate Excel Config Data object');
            }
            // Read file content and initiate validation
            try {
                const fileData = await file.getContentAsBinary();
                this.validateExcelFile(fileData, configType, forwardEvent, setErrorFlow);
            } catch (error) {
                this.logger.error(error);
                setErrorFlow(ErrorFlow.create(error, 0));
            }
        } catch (error) {
            this.logger.error(error.message);
            setErrorFlow(ErrorFlow.create(error, 1));
        }
    }

    /**
     * Validate Excel file against expected cells.
     * @param {ArrayBuffer} fileData
     * @param {Object} configType
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     */
    validateExcelFile(fileData, configType, forwardEvent, setErrorFlow) {
        let workbook;
        try {
            workbook = XLSX.read(fileData, {type: 'array', cellDates: true});
        } catch (error) {
            throw ErrorFlow.create(`Error reading Excel file: ${error.message}`, 2);
        }

        if (!workbook || !workbook.SheetNames || workbook.SheetNames.length === 0) {
            throw ErrorFlow.create('No valid sheets found in the Excel file', 3);
        }

        const expectedCells = loadConfig(configType);
        const validationResults = validateCells(workbook, expectedCells);
        if (validationResults.isValid) {
            forwardEvent();
        } else {
            setErrorFlow(createErrorFlowMessage(validationResults, 4));
        }
    }
}

registerBrick('018f05d695cbe2fe151c', ValidateExcel);
